<ngx-loading-bar [color]="'#7366ff'" [height]="'4px'" [includeSpinner]="false"></ngx-loading-bar>
<app-loader></app-loader>
<p-toast key="tc" position="top-center"></p-toast>
<app-tap-to-top></app-tap-to-top>
<app-filter-table></app-filter-table>
<router-outlet></router-outlet>
